import React from 'react';
import { Typography, Divider, Collapse } from 'antd';
import PropTypes from 'prop-types';

const { Text } = Typography;

const LABELS = {
  cargos_creados: 'Cargos creados',
  cargos_actualizados: 'Cargos actualizados',
  cargos_sin_cambios: 'Cargos sin cambios',
  cargos_cancelados: 'Cargos cancelados',

  cargos_accesorios_creados: 'Accesorios creados',
  cargos_accesorios_recalculados: 'Accesorios recalculados',
  cargos_accesorios_cancelados: 'Accesorios cancelados',

  actualizaciones_recalculadas: 'Actualizaciones recalculadas',
  recargos_recalculados: 'Recargos recalculados',
  gastos_recalculados: 'Gastos recalculados',

  descuentos_recalculados: 'Descuentos recalculados',
  descuentos_cancelados: 'Descuentos cancelados',
};

const ResultadoActualizacionCartera = ({ resultado }) => {
  if (!resultado) return null;

  const { mensaje, estadisticas = {}, errores = [] } = resultado;

  const estadisticasFiltradas = Object.entries(estadisticas)
    .filter(([, value]) => value > 0);

  return (
    <>
      <Text strong>{mensaje}</Text>

      <Divider />

      <Text strong>Resumen</Text>
      <ul>
        {estadisticasFiltradas.length ? estadisticasFiltradas.map(([key, value]) => (
          <li key={key}>
            {`${LABELS[key] || key.replaceAll('_', ' ')}: ${value}`}
          </li>
        )) : (<li>No hubo cambios</li>)}
      </ul>

      {!!errores.length && (
        <>
          <Divider />
          <Collapse>
            <Collapse.Panel
              header={`Errores encontrados (${errores.length})`}
              key="errores"
            >
              <ul>
                {errores.map((e) => (<li key={e}>{e}</li>))}
              </ul>
            </Collapse.Panel>
          </Collapse>
        </>
      )}
    </>
  );
};
ResultadoActualizacionCartera.propTypes = {
  resultado: PropTypes.shape({
    mensaje: PropTypes.string,
    estadisticas: PropTypes.objectOf(PropTypes.number),
    errores: PropTypes.arrayOf(PropTypes.string),
  }),
};

ResultadoActualizacionCartera.defaultProps = {
  resultado: null,
};

export default ResultadoActualizacionCartera;
